import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class RutaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerCombo(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: rutaInputType) {
          ruta {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: 1, cantidadRegistrosPorPagina: -1) {
              mensajes {
                tipo
                texto
                codigo
                contexto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  descripcion
                  sucursal_codigo
                  empresa_rut
                  estado
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.ruta.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
}
RutaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RutaService_Factory() { return new RutaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: RutaService, providedIn: "root" });
